import { render } from "./MaoFooter.vue?vue&type=template&id=bbb9ec58&scoped=true"
import script from "./MaoFooter.vue?vue&type=script&lang=js"
export * from "./MaoFooter.vue?vue&type=script&lang=js"

import "./MaoFooter.vue?vue&type=style&index=0&id=bbb9ec58&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbb9ec58"]])

export default __exports__